import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpProgressEvent } from '@angular/common/http';
import { Observable, of, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

    constructor(protected msalService: MsalService) {
        //   this._http = http;
        //   this.baseUrlLocal = environment.apiBaseUrl;
    }

    public getRoles(): Observable<string[]> {
        // Explicitly resolve the account so acquireTokenSilent never receives an
        // empty account reference, even between a redirect login completing and
        // inProgress$ emitting None (which is when setActiveAccount is normally called).
        const account =
            this.msalService.instance.getActiveAccount() ??
            this.msalService.instance.getAllAccounts()[0];

        return from(
            this.msalService.instance.acquireTokenSilent({
                scopes: [environment.appRegScope],
                account
            })
        ).pipe(
            map(result => {
                const token = result.accessToken;
                const decoded = this.decodeJwt(token);
                return decoded.roles || [];
            })
        );
    }

    private decodeJwt(token: string): any {
        if (!token) return null;
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    }
//   uploadExcelFile(file: File): Observable<HttpEvent<any>> {
//     const formData = new FormData();
//     formData.append('file', file);

//     return this._http.post(`${this.baseUrlLocal}excel/upload`, formData, {
//       reportProgress: true,
//       observe: 'events'
//     });
//   }
}